import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "auth_token";

export const setToken = token => {
  sessionStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
};

export const isTokenExpired = token => {
  if (!token) {
    return true;
  }

  try {
    const payload = parseToken(token);
    const expirationTime = payload.exp * 1000;
    return Date.now() >= expirationTime;
  } catch (error) {
    return true;
  }
};


export const parseToken = token => {
  if (!token) {
    return null;
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
};
